import { List as MUIList, ListProps } from '@mui/material';

export { default as ListItem, type IListItemProps } from './components/ListItem';
export { default as ListItemButton } from './components/ListItemButton';
export { default as ListItemText } from './components/ListItemText';
export { default as ListSubheader } from './components/ListSubheader';
export { default as ListItemAvatar } from './components/ListItemAvatar';

const List = (props: ListProps) => {
  const { children, ...restProps } = props;
  return <MUIList {...restProps}>{children}</MUIList>;
};

export default List;
